const state = function () {
  return {
    editorEntities: []
  }
}

const mutations = {
  setEditing (state, entity) {
    state.editorEntities.push(entity)
  }
}

const actions = {
  setEditing (context, entity) {
    context.commit('setEditing', entity.toString())
  }
}

const getters = {
  isEditing: (state) => (entity) => {
    return state.editorEntities.includes(entity)
  }
}

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/editor/index.js